'use strict';

var react = require('react');

function useCallbackRef(value) {
    const savedValueRef = react.useRef(value);
    react.useEffect(() => {
        savedValueRef.current = value;
    }, [value]);
    return savedValueRef;
}

exports.useCallbackRef = useCallbackRef;
//# sourceMappingURL=useCallbackRef.js.map
